import { ConfirmDialog } from '@gogame/components';
import { useMutation } from '@gogame/query';
import { useScreenModalV2 } from '@gogame/screens';

import { swapCreativeWithOriginal } from 'scenes/Gallery/GalleryPage/Creatives/sources/creatives';

import { update } from '../queryKeyFactory';

export const useSwapWithOriginal = () => {
  const showModal = useScreenModalV2(ConfirmDialog);

  const mutation = useMutation(
    update(),
    ({ id, conceptId }) =>
      swapCreativeWithOriginal({ creativeId: id, conceptId }),
    {
      successMessage: () => `Creative replaced`,
    }
  );

  const handleAction = async ({ id, conceptId }) => {
    await showModal({
      title: 'Swap with Original',
      bodyText:
        'Are you sure you want to replace the original with this variant?',
    });
    await mutation.mutateAsync({ id, conceptId });
  };

  return [handleAction, mutation];
};
